import { map } from 'lodash';

export const optionsFromStrings = (strings: any) =>
    map(strings, (key: string, value: string) => ({
        key,
        value,
    }));